<template>
  <span v-if="label" class="om-badge" :class="`om-badge-${status}`">{{ label }}</span>
</template>

<script>
import { CHANGE_BADGES } from './manualCopy';

export default {
  name: 'ManualChangeBadge',
  props: {
    status: { type: String, default: '' },
  },
  computed: {
    label() {
      return CHANGE_BADGES[this.status] || '';
    },
  },
};
</script>

<style scoped>
.om-badge { display: inline-block; flex-shrink: 0; font-size: 11px; font-weight: 700; letter-spacing: .03em; padding: 3px 8px; border-radius: 999px; line-height: 1.3; }
.om-badge-new { background: var(--om-green-tint); color: var(--om-green-dark); border: 1px solid rgba(93, 188, 133, .4); }
.om-badge-updated { background: var(--om-amber-tint); color: var(--om-amber); border: 1px solid rgba(236, 170, 51, .45); }
</style>
